import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";
const backgrounds = {
  canvas: "woha-background-canvas",
  paper: "woha-background-paper",
  mint: "woha-background-mint",
  blue: "woha-background-blue",
  violet: "woha-background-violet",
  dots: "woha-background-dots",
} as const;
export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;
  return (
    <div
      className={cn(
        background ? backgrounds[background as keyof typeof backgrounds] : backgrounds.canvas,
        parentClass,
      )}
      data-background={background || "canvas"}
      data-background-container=""
    >
      {components}
    </div>
  );
};
BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
